import s from "./contact.module.scss";
import { Container } from "../../components/container";
import { Title } from "../../components/title";
import { MyButton } from "../../components/button";
import { ContactCard } from "../../components/contact/contactCard";
import { Row, Col } from "antd";
import { MdLocationPin, MdLocalPhone } from "react-icons/md";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";
import { useState, useEffect, useContext } from "react";
import { ColorContext } from "../../context/colorContext";
import { notification } from "antd";
import { gsap } from "gsap";
import { useTranslation } from "react-i18next";

export const Contact = ({ reference }) => {
  const [load, setLoad] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const { color } = useContext(ColorContext);
  const { t } = useTranslation();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(`.${s.contact}`, {
        duration: 1,
        y: 100,
        opacity: 0,
      });
    }, reference);
    return () => ctx.revert();
  }, [reference]);

  const onSub = (e) => {
    e.preventDefault();
    let text = `{email:${email},name:${name},message:${message}`;
    setLoad(true);
    fetch(
      `https://api.telegram.org/bot6181555617:AAHe0ndg2Qik81hVkLH0fK3admjJYKfo1T8/sendMessage?chat_id=953063060&text=${text}`
    )
      .then((res) => res.json())
      .then((d) => {
        setLoad(false);
        if (d.ok)
          notification.success({
            message: "Success",
            description: "Message was sent successfully",
          });
        else
          notification.error({ message: "Error", description: d.description });
      })
      .catch((err) => {
        setLoad(false);
        notification.error({ message: "Error", description: err.message });
      });
    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <div className={s.contact}>
      <Container>
        <div className={s.title}>
          <Title span={t("contact_title2")} size={25}>
            {t("contact_title1")}
          </Title>
        </div>
        <hr />
        <Row justify={{ xs: "center", sm: "center", md: "space-between" }}>
          <Col xs={24} sm={24} md={10}>
            <ContactCard
              icon={
                <MdLocationPin
                  style={{
                    fontSize: 18,
                    verticalAlign: "middle",
                    color: color,
                  }}
                />
              }
            >
              <a href="https://www.google.com/maps/@41.36511,69.2787419,17z">
                Tashkent
              </a>
            </ContactCard>
            <ContactCard
              icon={
                <MdLocalPhone
                  style={{
                    fontSize: 18,
                    verticalAlign: "middle",
                    color: color,
                  }}
                />
              }
            >
              <a href="tel:+998979269566">+998 97 926 95 66</a>
            </ContactCard>
            <ContactCard
              icon={
                <BsFillEnvelopeFill
                  style={{
                    fontSize: 18,
                    verticalAlign: "middle",
                    color: color,
                  }}
                />
              }
            >
              <a href="mailto:ulugbek8848@gmail.com">ulugbek8848@gmail.com</a>
            </ContactCard>
            <ContactCard
              icon={
                <FaTelegramPlane
                  style={{
                    fontSize: 18,
                    verticalAlign: "middle",
                    color: color,
                  }}
                />
              }
            >
              <a href="https://t.me/Dasturchi_Ulugbek">@Dasturchi_Ulugbek</a>
            </ContactCard>
          </Col>
          <Col xs={24} sm={24} md={10}>
            <form onSubmit={onSub}>
              <div className={s.inputs}>
                <input
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  type="text"
                  placeholder={t("contact_name")}
                  required
                />
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="email"
                  placeholder={t("contact_email")}
                  required
                />
              </div>
              <textarea
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                placeholder={t("contact_message")}
                id=""
                cols="30"
                rows="6"
                required
              ></textarea>
              <MyButton loading={load} htmlType="submit">
                {t("contact_sendMessage")}
              </MyButton>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
